import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of, combineLatest } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { uiClientsConfig } from 'admin-ui-v2-config';
import { ApisService } from '../../services/apis.service';

export const EMAIL_VALIDATOR_PERMISSION = 'CMT Email Validator Show';

@Injectable({ providedIn: 'root' })
export class EmailValidatorGuard implements CanActivate {
  constructor(private router: Router, private apiService: ApisService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
     const hidePhiAccess$ = this.apiService.getUserProfileDetail().pipe(
      map((result: any) => !!result?.data?.hidePhiInCampaign),
      catchError(() => of(false))
    );
    const hasPermission$ = this.apiService.getValidPermission(EMAIL_VALIDATOR_PERMISSION, false).pipe(
      map((result: any) => !!result?.data?.hasPermission),
      catchError(() => of(false))
    );

    const featureEnabled$ = this.apiService.getCommunicationTabPermission(uiClientsConfig.customerUrlPrefix).pipe(
      map((result: any) => !!result?.data?.focusBrandConfiguration?.isMailgunEmailValidationEnabledForCMT),
      catchError(() => of(false))
    );

    return combineLatest([hidePhiAccess$, hasPermission$, featureEnabled$]).pipe(
      map(([hidePhiAccess, hasPermission, featureEnabled]) => {
        if (!hidePhiAccess && hasPermission && featureEnabled) {
          return true;
        }

        const fullUrl = state.url || '/';
        const pathOnly = fullUrl.split(/[?#]/)[0];
        const parentPath = pathOnly.replace(/\/[^\/]*$/, '') || '/';

        return this.router.parseUrl(parentPath);
      }),
      catchError((err) => {
        const fullUrl = state.url || '/';
        const pathOnly = fullUrl.split(/[?#]/)[0];
        const parentPath = pathOnly.replace(/\/[^\/]*$/, '') || '/';
        return of(this.router.parseUrl(parentPath));
      })
    );
  }
}
